import { RootState } from '../store';

export const planPermissionSelector = (state: RootState) =>
  state.planPermission;
